export default __webpack_public_path__ + "static/media/bg4.704fba3f.jpg";